import React from 'react'
import { Link } from 'react-router-dom';
import { checkPermission } from '../../helpers/commonFunctions';


const ConfigurationReportTab = ({ tab: Tab }) => {

    return (
        <ul className='d-flex setting w-100 mb-0 p-0'>
            {checkPermission('store_reports', 'view') && (
                <>
                    <li className={Tab === 'sales' ? 'active' : ''}>
                        <Link to={`/company/report/sales_report/list/${1}`} className="btn">
                            Sales Report
                        </Link>
                    </li>
                    <li className={Tab === 'customer' ? 'active' : ''}>
                        <Link to={`/company/report/customer_report/list/${1}`} className="btn">
                           Customer Report
                        </Link>
                    </li>
                    <li className={Tab === 'category' ? 'active' : ''}>
                        <Link to={`/company/report/primary_category_report/list/${1}`} className="btn">
                            Primary Category Report
                        </Link>
                    </li>
                    <li className={Tab === 'inventory' ? 'active' : ''}>
                        <Link to={`/company/report/inventory_report/list/${1}`} className="btn">
                           Inventory Report
                        </Link>
                    </li>
                    <li className={Tab === 'payment' ? 'active' : ''}>
                        <Link to={`/company/report/payment_report/list/${1}`} className="btn">
                            Payment Report
                        </Link>
                    </li>
                    <li className={Tab === 'cost' ? 'active' : ''}>
                        <Link to={`/company/report/item_cost/list/${1}`} className="btn">
                            Item Cost Calculations
                        </Link>
                    </li>
                    <li className={Tab === 'stock' ? 'active' : ''}>
                        <Link to={`/company/report/stock_movement/list/${1}`} className="btn">
                           Stock Movement
                        </Link>
                    </li>
                </>
            )}
            {checkPermission('store_erp', 'view') && (
                <li className={Tab === 'erp' ? 'active' : ''}>
                    <Link to={`/company/report/erp/list/${1}`} className="btn">
                      ERP Management
                    </Link>
                </li>
            )}
        </ul>
    );
}

export default ConfigurationReportTab
